import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApplicationState } from 'state';

@Injectable({
    providedIn: 'root'
})
export class LoginGuard  {
    private isAuthenticated$: Observable<boolean>;

    constructor(private store: Store<ApplicationState>, private router: Router) {
        this.isAuthenticated$ = this.buildIsAuthenticatedStream();
    }

    canActivate(): Observable<boolean | UrlTree> {
        return this.isAuthenticated$.pipe(
            map(result => {
                return !result || this.router.parseUrl('/');
            })
        );
    }

    private buildIsAuthenticatedStream(): Observable<boolean> {
        return this.store.select(state => state.authentication.isAuthenticated);
    }
}
